module.exports = __webpack_public_path__ + "static/media/Hero_Image_Tablet.e7fe03c1.jpg";